import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from '../services/data.service';

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {

  constructor(
    private data: DataService
  ){}

  /**
   * 
   * 
   * @param value 
   * @param args 
   * 
   */
  transform(value:any,args:any):any{
    
    let linguagem = this.data.getLinguagem();

    return value;

  }

}
